<template>
<div>
    <div class="caption overed" @click="$emit('pushed')">{{text}}</div>
</div>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['text']
}
</script>

<style scoped>
    .overed {
        cursor: pointer;
    }
    .overed:hover {
        color: red;
    }
</style>